export default __webpack_public_path__ + "static/media/gallery-wip-neck_00.ce8525e2.jpg";